import React, {useContext} from 'react';
import {DateTimeContext} from "../contexts/DateTimeContext";
import {GlobalContext} from "../contexts/Provider";

const formatDate = (date) => {
    var month = '' + (date.getMonth() + 1),
        day = '' + date.getDate(),
        year = date.getFullYear();

    if (month.length < 2)
        month = '0' + month;
    if (day.length < 2)
        day = '0' + day;

    return [day, month, year].join('.');
}

const formatTime = (date) => {
    var hours = '' + date.getHours(),
        minutes = '' + date.getMinutes();

    if (hours.length < 2)
        hours = '0' + hours;
    if (minutes.length < 2)
        minutes = '0' + minutes;

    return [hours, minutes].join(':');
}
const ContactPerson = () => {

    const {
        state: {
            member,
            date,
            time
        }
    } = useContext(DateTimeContext);

    const {
        state: {
            store
        },
    } = useContext(GlobalContext);

    if(member) {
        return (
            <div className="w-full flex flex-col gap-4 p-4 border border-neutrals-700 max-w-xl">
                <p className="text-white text-lg">Ihr Termin mit dem Berater:</p>
                <div className="flex justify-between items-center">
                    <p className="text-white font-bold">{formatDate(date)}, {formatTime(time)}</p>
                </div>
                <div className="flex flex-row gap-4">
                    <img src={member.img?.url} alt={member.name} className="w-24 h-24" />
                    <div className="flex flex-col justify-center gap-2">
                        <p className="text-white text-24">{member.name}</p>
                        <p className="text-gray-600 text-xs">{member.work_position}</p>
                    </div>
                </div>
                <div className="flex flex-col gap-2">
                    <div className="flex gap-2 items-center">
                        <img className="w-4 h-4" src="/images/icons/other/icon_location-400.svg" alt=""/>
                        <p className="text-gray-400">{store.address}</p>
                    </div>
                    <div className="flex gap-2 items-center">
                        <img className="w-4 h-4" src="/images/icons/other/icon_phone-empty-400.svg" alt=""/>
                        <p className="text-gray-400">{member.phone}</p>
                    </div>
                </div>
            </div>
        );
    } else {
        return <></>;
    }
};

export default ContactPerson;
